<script setup>
import { computed } from "vue";
import { useAuthStore } from "@/stores/auth-store";

const props = defineProps({
  course: {
    type: Object,
    required: true,
  },
  status: {
    type: String,
    default: "",
  },
});

const authStore = useAuthStore();

const detailRoute = computed(() => ({
  name: "CourseDetail",
  params: { course_id: props.course.course_id },
}));

const statusBadgeClass = computed(() => {
  const map = {
    Ongoing: "bg-warning",
    Completed: "bg-success",
    Expired: "bg-danger",
    Active: "bg-success",
    New: "bg-warning",
    Disabled: "bg-danger",
  };
  return map[props.status] || "bg-light";
});

const thumbnailSrc = computed(
  () => `${authStore.Url}/media/${props.course.thumbnail}`
);

const instructorPhoto = computed(
  () =>
    `${authStore.authUrl}/storage/photo/${authStore.userPhoto(
      props.course.instructor
    )}`
);

const instructorName = computed(() =>
  authStore.userName(props.course.instructor)
);
</script>

<template>
  <div class="course-item-two course-item mx-0 h-100">
    <div class="course-img">
      <router-link :to="detailRoute">
        <img
          :src="thumbnailSrc"
          :alt="course.title || 'Course thumbnail'"
          class="img-fluid"
        />
      </router-link>
    </div>
    <div class="course-content">
      <div
        class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2"
      >
        <div class="d-flex align-items-center min-w-0">
          <img
            :src="instructorPhoto"
            :alt="instructorName || 'Instructor'"
            class="img-fluid avatar avatar-sm rounded-circle flex-shrink-0"
          />
          <div class="ms-2 text-truncate fs-14" :title="instructorName">
            {{ instructorName }}
          </div>
        </div>
        <span
          v-if="status"
          class="badge badge-light rounded-pill d-inline-flex align-items-center fs-13 fw-medium mb-0 flex-shrink-0 text-nowrap"
          :class="statusBadgeClass"
        >
          {{ status }}
        </span>
      </div>
      <h6 class="title mb-2">
        <router-link :to="detailRoute" :title="course.title">
          {{ course.title }}
        </router-link>
      </h6>
      <div
        class="d-flex align-items-center justify-content-between flex-wrap gap-2"
      >
        <h5
          class="text-secondary mb-0 text-truncate min-w-0 flex-grow-1"
          :title="course.level"
        >
          {{ course.level || "—" }}
        </h5>
        <router-link
          :to="detailRoute"
          class="btn btn-dark btn-sm d-inline-flex align-items-center flex-shrink-0 text-nowrap"
        >
          View Course
          <i class="isax isax-arrow-right-3 ms-1" aria-hidden="true"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>
